export default __webpack_public_path__ + "static/media/wnew5.bce97ca2.png";